import NavWrapper from '@App/components/NavWrapper/NavWrapper';
import MapLayout from '@App/components/MapLayout/MapLayout';
import Consumers from '@App/pages/Consumers/Consumers';
import FlowingWater from '@App/pages/Sources/FlowingWater/FlowingWater';
import FlowingWater100m from '@App/pages/Sources/FlowingWater/FlowingWater100m/FlowingWater100m';
import StillWater from '@App/pages/Sources/StillWater/StillWater';
import StillWaterCell from '@App/pages/Sources/StillWater/StillWaterCell/StillWaterCell';
import SewageWater from '@App/pages/Sources/SewageWater/SewageWater';
import Collector from '@App/pages/Sources/Collector/Collector';
import Municipality from '@App/pages/Consumers/Municipality/Municipality';
import StatisticalSector from '@App/pages/Consumers/Municipality/StatisticalSector/StatisticalSector';
import Sources from '@App/pages/Sources/Sources';
import Constraints from '@App/pages/Constraints/Constraints';
import NoMatch from '@App/pages/NoMatch/NoMatch';

const routes = [
  {
    element: <NavWrapper />,
    children: [
      {
        element: <MapLayout />,
        path: '/',
        children: [
          {
            path: 'bronnen',
            element: <Sources />,
            handle: { name: 'Bronnen' },
            children: [
              {
                path: 'stromend-water/:stromendWaterId',
                handle: {
                  name: 'Stromend Water',
                  showPotentialGraphPanel: true,
                },
                element: <FlowingWater />,
              },
              {
                path: 'stromend-water/:stromendWaterId/:stromendWaterStukje100mId',
                handle: {
                  name: 'Stromend Water Stukje 100m',
                  showTimelineGraphPanel: true,
                },
                element: <FlowingWater100m />,
              },
              {
                path: 'stilstaand-water/:stilstaandWaterId',
                handle: { name: 'Stilstaand Water' },
                element: <StillWater />,
              },
              {
                path: 'stilstaand-water/:stilstaandWaterId/:stilstaandWaterCellId',
                handle: {
                  name: 'Stilstaand Water Cel',
                  showTimelineGraphPanel: true,
                },
                element: <StillWaterCell />,
              },
              {
                path: 'rwzi/:rwziId',
                handle: { name: 'RWZI' },
                element: <SewageWater />,
              },
              {
                path: 'collector/:collectorId',
                handle: { name: 'Collector' },
                element: <Collector />,
              },
            ],
          },
          {
            path: 'afnemers',
            element: <Consumers />,
            handle: { name: 'Afnemers' },
            children: [
              {
                path: ':municipalityId',
                element: <Municipality />,
                handle: { name: 'Gemeente' },
              },
              {
                path: ':municipalityId/:statisticalSectorId',
                element: <StatisticalSector />,
                handle: { name: 'Statistical Sector' },
              },
            ],
          },
          {
            path: 'randvoorwaarden',
            element: <Constraints />,
            handle: { name: 'Randvoorwaarden' },
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NoMatch />,
  },
];

export default routes;
